module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/discover-payment-card-1b3896d23535e93e7578cc507c10116e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/discover-payment-card.svg
// module id = 8zDh
// module chunks = 24